import { render, staticRenderFns } from "./HeaderShimer.vue?vue&type=template&id=01636432&"
import script from "./HeaderShimer.vue?vue&type=script&lang=js&"
export * from "./HeaderShimer.vue?vue&type=script&lang=js&"
import style0 from "./HeaderShimer.vue?vue&type=style&index=0&id=01636432&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports